import React from "react";
import "./MainHeader.scss";

const MainHeader = (props) => {
  return (
    <div className="MainHeader">
      <div className="bg"></div>
      <div className="main-content">
        <h1>BleepSleep</h1>
        <p>
          Providing the Best Items in United Kingdom. Our service is the one of
          the best you can find in UK.
        </p>
      </div>
    </div>
  );
};

export default MainHeader;
